/** @returns {import('./agentQuestionTypes.js').AgentQuestionPayload} */
export function buildCreateAgentQuestionPayload() {
  return {
    id: `agent-question-${Date.now()}`,
    status: 'open',
    prompt: 'What would you like to create?',
    options: [
      { id: 'a', letter: 'A', label: 'XlSheet' },
      { id: 'b', letter: 'B', label: 'Doc' },
      { id: 'c', letter: 'C', label: 'APP' },
      { id: 'd', letter: 'D', label: 'Other' },
    ],
    allowFreeText: true,
    agentBrand: 'SIA',
    agentName: 'Master Root Agent',
  }
}
